import React from 'react';
import { md } from './ReportShared';

interface CapstoneFeedbackDisplayProps {
    result: any;
}

const CapstoneFeedbackDisplay: React.FC<CapstoneFeedbackDisplayProps> = ({ result }) => {
    return (
        <div className="space-y-6">
            <div className="bg-blue-50 p-4 rounded-md border border-blue-100">
                <h3 className="font-semibold text-blue-900 mb-2">Overall Assessment</h3>
                <p className="text-blue-800 text-sm leading-relaxed">{result.overallAssessment}</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                    <h3 className="font-bold text-green-700 flex items-center gap-2 mb-3">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                        Strengths
                    </h3>
                    <div className="prose prose-sm text-slate-600 bg-green-50/50 p-4 rounded-lg border border-green-100" dangerouslySetInnerHTML={{ __html: md.render(result.strengths || '') }} />
                </div>
                <div>
                    <h3 className="font-bold text-amber-700 flex items-center gap-2 mb-3">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" /></svg>
                        Areas for Improvement
                    </h3>
                    <div className="prose prose-sm text-slate-600 bg-amber-50/50 p-4 rounded-lg border border-amber-100" dangerouslySetInnerHTML={{ __html: md.render(result.areasForImprovement || '') }} />
                </div>
            </div>
        </div>
    );
};

export default CapstoneFeedbackDisplay;
